import { configureStore } from '@reduxjs/toolkit'

import authReducer from './slices/authSlice'
import dashboardConfigReducer from './slices/dashboardConfigSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboardConfig: dashboardConfigReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
